import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import AreaForm from './components/area-form/AreaForm';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { ModelName } from '@casops/store/api';
import { useModelFormTitle } from '@casops/components/layout/model-form/useModelFormTitle';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useGetGeofenceAreaQuery } from '@casops/store/apis/geofenceAreasApi';

const modelName = ModelName.GeofenceArea;

export function ManageGeofenceArea(): ReactElement {
  const title = useModelFormTitle(modelName);

  const { isLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetGeofenceAreaQuery,
  });

  // The renderKey must update whenever the item data changes to ensure the form is remounted and RHK and VDS stay in sync.
  const renderKey = useRenderKey(item ? item : 'create-form');

  return (
    <DrawerPanel isLoaded={isLoaded} header={title}>
      <AreaForm key={renderKey} item={item} />
    </DrawerPanel>
  );
}

export default ManageGeofenceArea;
